'use client';

import { searchModule } from './Engine';
import { SearchPageLayout } from './SearchPageLayout';

export const SearchV2Page = () => (
  <SearchPageLayout
    engineModule={searchModule}
    resultSectionTestId="search-result-section"
  />
);
